import { QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError } from "@/api/errors";
import { qk } from "@/api/hooks";

/** Query client: no retries on 4xx; a 401 anywhere re-checks the session (→ login). */
export function createQueryClient(): QueryClient {
  const qc: QueryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (err, query) => {
        if (!(err instanceof ApiError) || query.queryKey[0] === "auth") return;
        if (err.isUnauthorized) {
          // Session expired: drop it; RequireAuth sends the user to /login.
          qc.setQueryData(qk.me, null);
          void qc.invalidateQueries({ queryKey: qk.me });
        } else if (err.status === 403 && err.code === "totp_setup_required") {
          // C2 limited session: /auth/me reports totp_setup_required → login setup step.
          void qc.invalidateQueries({ queryKey: qk.me });
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        refetchOnWindowFocus: true,
        retry: (count, err) => {
          if (err instanceof ApiError && err.status >= 400 && err.status < 500) return false;
          return count < 2;
        },
      },
      mutations: { retry: false },
    },
  });
  return qc;
}
